import { Accordion, AccordionDetails, AccordionSummary } from '@unifyapps/ui/components/Accordion';
import type { NotificationEventType } from '../../types';
import { EventsPreferences } from './EventsPreferences';
import { GroupHeader } from './GroupHeader';

const DETAILS_SLOT_PROPS = {
  content: { className: 'p-0' },
  root: { className: 'w-full' },
};
const SUMMARY_SLOT_PROPS = {
  root: { className: 'p-0 w-full' },
  button: { className: 'px-md hover:!bg-primary mb-md gap-lg flex items-start pt-xs' },
  indicator: {
    className: String.raw`hover:bg-[var(--button-neutral-secondary-bg\_hover)] rounded-xs`,
  },
};
const ROOT_SLOT_PROPS = { root: { className: 'p-0 flex items-center' } };

type Props = {
  name: string;
  onToggleEvent: (groupName: string, eventType: string, channelType: string) => void;
  onToggleGroup: (groupName: string, channelType: string) => void;
  channelTypes: { id: string; name: string }[];
  preferences: Record<string, Record<string, boolean>>;
  events: NotificationEventType[];
  groupId: string;
};

export function GroupSettings({
  name,
  onToggleEvent,
  onToggleGroup,
  events,
  channelTypes,
  preferences,
  groupId,
}: Props & {
  events: NotificationEventType[];
}) {
  return (
    <Accordion defaultExpanded slotProps={ROOT_SLOT_PROPS}>
      <AccordionSummary className="border-tertiary border-b" slotProps={SUMMARY_SLOT_PROPS}>
        <GroupHeader
          channelTypes={channelTypes}
          events={events}
          groupId={groupId}
          name={name}
          onToggleGroup={onToggleGroup}
          preferences={preferences}
        />
      </AccordionSummary>
      <AccordionDetails slotProps={DETAILS_SLOT_PROPS}>
        <EventsPreferences
          channelTypes={channelTypes}
          events={events}
          groupId={groupId}
          onToggleEvent={onToggleEvent}
          preferences={preferences}
        />
      </AccordionDetails>
    </Accordion>
  );
}
